import axiosInstance from './axiosInstance';

/**
 * Contact-us submissions (admin).
 * Server returns { data, stats, pagination }.
 */
export const fetchContactSubmissions = async (params = {}) => {
  const res = await axiosInstance.get('/admin/contact-submissions', { params });
  return res.data;
};

export const updateContactSubmissionStatus = async (id, status) => {
  const res = await axiosInstance.patch(`/admin/contact-submissions/${id}/status`, { status });
  return res.data;
};

export const deleteContactSubmission = async (id) => {
  const res = await axiosInstance.delete(`/admin/contact-submissions/${id}`);
  return res.data;
};
